<div class="message-summary-column">
	<div *ngFor="let msg of conversations; let i = index" style="padding: 0">
		<button
			id="message-panel-message-button-{{ i }}"
			mat-button
			style="
				background: #fff;
				border-top: 1px solid #ddd;
				border-bottom: 1px solid #ddd;
				cursor: pointer;
				width: 100%;
				height: 100%;
				border-radius: 0px;
				margin: 0 0 10px 0;
			"
			(click)="goToMessage(msg.conversationId)"
			[ngClass]="{ highlight: msg.hasUnreadMessages && msg.messages.length > 1 }"
		>
			<!--Move Icon outside of main div on mobile-->
			<div class="message-icon mobile">
				<fa-icon
					*ngIf="msg?.conversationStatus?.codeName.toUpperCase() == 'OPEN'"
					[icon]="$any(faIcons.faCommentDots)"
					style="font-size: 30px; color: #76a5af"
				></fa-icon>
				<fa-icon
					*ngIf="msg?.conversationStatus?.codeName.toUpperCase() == 'CLOSED'"
					[icon]="$any(faIcons.faCommentCheck)"
					style="font-size: 30px; color: #ababab"
				></fa-icon>
			</div>

			<div style="display: flex; flex-flow: row; align-content: stretch">
				<!--Show Icon in same div on desktop-->
				<div class="message-icon desktop">
					<fa-icon
						*ngIf="msg?.conversationStatus?.codeName.toUpperCase() == 'OPEN'"
						[icon]="$any(faIcons.faCommentDots)"
						style="font-size: 30px; color: #76a5af"
					></fa-icon>
					<fa-icon
						*ngIf="msg?.conversationStatus?.codeName.toUpperCase() == 'CLOSED'"
						[icon]="$any(faIcons.faCommentCheck)"
						style="font-size: 30px; color: #ababab"
					></fa-icon>
				</div>

				<div style="display: flex; flex-flow: column; padding: 15px 0 15px 10px; width: 100%; overflow: hidden">
					<div class="message-summery-row">
						<div
							style="
								font-size: 16px;
								text-overflow: ellipsis;
								white-space: nowrap;
								overflow: hidden;
								text-align: left;
								color: var(--ht-app-primary, var(--ion-color-primary));
							"
						>
							{{ msg.conversationCategory.languageKey | translate }}
						</div>
					</div>
					<div class="message-summery-row">
						<div
							style="
								display: flex;
								flex-flow: column;
								align-items: flex-start;
								overflow: hidden;
								text-overflow: ellipsis;
							"
						>
							<div>
								<strong>{{ 'DATE' | translate }}:</strong> {{ msg?.createdDate | date: 'M/d/yyyy' }}
							</div>
						</div>
					</div>
					<div class="message-summery-row">
						<div
							style="
								display: flex;
								flex-flow: column;
								align-items: flex-start;
								overflow: hidden;
								text-overflow: ellipsis;
							"
						>
							<div>
								<strong>{{ 'STATUS' | translate }}:</strong>
								{{ msg?.conversationStatus?.codeName.toUpperCase() | translate }}
							</div>
						</div>
					</div>
					<div class="message-summery-row" *ngIf="showDisplayName">
						<div
							style="
								display: flex;
								flex-flow: column;
								align-items: flex-start;
								overflow: hidden;
								text-overflow: ellipsis;
							"
						>
							<div>
								<strong>{{ 'ENROLLMENT_MEMBER' | translate }}:</strong> {{ msg?.displayName }}
							</div>
						</div>
					</div>
					<div class="message-summery-row">
						<div
							style="
								display: flex;
								flex-flow: column;
								align-items: flex-start;
								overflow: hidden;
								text-overflow: ellipsis;
							"
						>
							<div>
								<strong>{{ 'RESPONSE_CONTACT_METHOD' | translate }}:</strong>
								{{ msg?.conversationResponseType?.codeName.toUpperCase() | translate }}
							</div>
						</div>
					</div>
					<div class="message-summery-row" *ngIf="msg?.conversationResponseType?.codeName == 'Call'">
						<div
							style="
								display: flex;
								flex-flow: column;
								align-items: flex-start;
								overflow: hidden;
								text-overflow: ellipsis;
							"
						>
							<div>
								<strong>{{ 'PREFERRED_TIME' | translate }}:</strong> {{ msg?.contactTime?.description }}
							</div>
						</div>
					</div>
				</div>
				<div class="open-message-icon">
					<mat-icon
						[ngClass]="{
							selected: msg.conversationId == selectedId,
							unselected: msg.conversationId != selectedId
						}"
						aria-hidden="false"
						aria-label="Example home icon"
						style="font-size: 16px; color: var(--ht-app-primary, var(--ion-color-primary))"
						>arrow_forward_ios</mat-icon
					>
				</div>
			</div>
		</button>
	</div>
</div>
